import React, { Component, Dispatch } from 'react';
import { Button, Modal } from 'reactstrap';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../../models/action/core';
import { IPreference } from '../../../models/action/profile';
import { Confirm, Notification } from '../../notification/main';
import RemovedStudents from '../assigned-student-tabs/removed-students-tab-list';
import AssignedStudents from '../assigned-student-tabs/assigned-students-tab-list';
import { IExamData } from '../../../models/action/exam';
import { FormikContext } from 'formik';
import StudentTabs from '../assigned-student-tabs/student-tabs';
import { ISetAssignmentStudentList } from '../../../models/action/assignment';
import { IStudents } from '../../../models/components/add-assignment';
import { IFilterAssignmentStudents } from '../../../models/components/add-assignment';
import * as Actions from '../../../store/actions/assignment';

let _common: Common;
const T = Translator.create();
const _logger = Log.create('Assigned Student Modal Page');

interface IAssignedStudentModalState {
    currentTab: string;
    validations: any;
}

interface IAssignedStudentModalProps {
    isModalOpen: boolean;
    assignedStudentDatas?: ISetAssignmentStudentList;
    removedStudentDatas?: ISetAssignmentStudentList;
    setCloseModal: (assignedStudentDatas: ISetAssignmentStudentList, removedStudentDatas: ISetAssignmentStudentList, currentTab: string) => void;
    dispatch?: any;
    updateActivityId?: string;
    currentTab: string;
    classIds: Array<string>;
}

class CAssignedStudentModal extends Component<IAssignedStudentModalProps, IAssignedStudentModalState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            currentTab: '_sessionProperties',
            validations: {}
        };
    }

    componentDidUpdate(prevProps: IAssignedStudentModalProps) {
        if (this.props.currentTab !== prevProps.currentTab) {
            this.setState({ currentTab: this.props.currentTab });
        }
    }

    onCloseModal = () => {
        let clearStudentDatas = { users: [], filters: {}, type: '', timestamp: 0 };
        this.props.setCloseModal(clearStudentDatas, clearStudentDatas, '_activitySettingTab');
    };

    public onClickCancel = () => {
        Confirm.setConfirm('checkControl', () => {
            const filtersGetStudents: IFilterAssignmentStudents = {
                ActivityId: this.props.updateActivityId ? this.props.updateActivityId : "",
                SelectedClasses: this.props.classIds,
                SearchedText: "",
                IsAdded: false
            };
            this.props.dispatch(Actions.AssignmentStudentList(filtersGetStudents, { IsAdded: filtersGetStudents.IsAdded, page: 1, take: 99999, total: 0 }, '', 'get'));

            const filtersGetAddedStudents: IFilterAssignmentStudents = {
                ActivityId: this.props.updateActivityId ? this.props.updateActivityId : "",
                SelectedClasses: this.props.classIds,
                SearchedText: "",
                IsAdded: true
            };
            this.props.dispatch(Actions.AssignmentStudentList(filtersGetAddedStudents, { page: 1, take: 99999, total: 0 }, 'added', 'get'));

            this.onCloseModal()
        }, T.t('r_close_assign_modal'), null);
    };

    public onSaveChanges = () => {
        if (this.props.assignedStudentDatas && this.props.assignedStudentDatas.users && this.props.assignedStudentDatas.users.length === 0) {
            Notification.setNotification(
                'error',
                T.t('r_least_one_student_must_be_assigned'),
                'topRight'
            );
        } else {
            this.onCloseModal();
        }
    };

    changeTab = (tabName: string) => {
        this.setState({
            currentTab: tabName
        });
    };

    render() {
        return (
            <Modal
                className="pt-0"
                style={{ maxWidth: '100vw' }}
                isOpen={this.props.isModalOpen}
                toggle={this.onCloseModal}
                fade={true}
                backdrop={'static'}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title d-inline-flex align-items-center" style={{marginInlineEnd: 'auto'}} id="exampleModalLabel">
                            {T.t('r_gen_exam_session_add_page_students')}
                        </h6>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body" style={{ padding: 0, background: 'rgb(251, 250, 246)' }}>
                        <div className="container-fluid p-0">
                            <div className="row mt-0">
                                <div className="col-12 modal-from-right">
                                    <StudentTabs
                                        changeTab={this.changeTab}
                                        currentTab={this.state.currentTab}
                                        removedStudentDatas={this.props.removedStudentDatas ? this.props.removedStudentDatas : { users: [], filters: {}, type: '', timestamp: 0 }}
                                        assignedStudentDatas={this.props.assignedStudentDatas ? this.props.assignedStudentDatas : { users: [], filters: {}, type: '', timestamp: 0 }}
                                    />
                                    <div className="tab-content" id="tabContent" style={{ padding: '1rem', background: '#fbfaf6' }}>
                                        <RemovedStudents
                                            removedStudentDatas={this.props.removedStudentDatas ? this.props.removedStudentDatas : { users: [], filters: {}, type: '', timestamp: 0 }}
                                            assignedStudentDatas={this.props.assignedStudentDatas ? this.props.assignedStudentDatas : { users: [], filters: {}, type: '', timestamp: 0 }}
                                            currentTab={this.state.currentTab}
                                            examId={this.props.updateActivityId}
                                        />
                                        <AssignedStudents
                                            removedStudentDatas={this.props.removedStudentDatas ? this.props.removedStudentDatas : { users: [], filters: {}, type: '', timestamp: 0 }}
                                            assignedStudentDatas={this.props.assignedStudentDatas ? this.props.assignedStudentDatas : { users: [], filters: {}, type: '', timestamp: 0 }}
                                            currentTab={this.state.currentTab}
                                            examId={this.props.updateActivityId}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-block">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="">
                                        <button
                                            type="button"
                                            className="btn btn-gray"
                                            onClick={this.onClickCancel}
                                        >
                                            {T.t('r_cancel_button')}
                                        </button>
                                    </div>
                                    <div className="">
                                        <button
                                            type="button"
                                            className="btn btn-success ml-2"
                                            onClick={() => this.onSaveChanges()}
                                        >
                                            {T.t('r_gen_save')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAssignedStudentModalProps): IAssignedStudentModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAssignedStudentModalProps = Object.assign({}, ownProps, {
        removedStudentDatas: state.assignment.removedStudentDatas,
        assignedStudentDatas: state.assignment.assignedStudentDatas
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.assignment.removedStudentDatas === prev.assignment.removedStudentDatas &&
        next.assignment.assignedStudentDatas === prev.assignment.assignedStudentDatas
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const AssignedStudentModal = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CAssignedStudentModal);

export default AssignedStudentModal;
